import { TextStyle } from './styles';
import { buildElements, findWrappedParts, sortStylesByLength } from './utils';

type TextHighlighterProps = {
  children: string;
  styles: TextStyle[];
};

export function TextHighlighter({ children, styles }: TextHighlighterProps) {
  const sortedStyles = sortStylesByLength(styles);
  const wrappedParts = findWrappedParts(children, sortedStyles);
  const elements = buildElements(children, wrappedParts);

  return <>{elements}</>;
}
